<template>
  <ConfirmModal
    :visible-sync="visible"
    :is-single="!isRewardComplete"
    first-button-id="gtm_popup_cancel_btn"
    second-button-id="gtm_popup_confirm_btn"
    @click-close="handleClose"
    @click-confirm="handleConfirm"
  >
    <template #header>
      {{ title }}
    </template>
    <template #content>
      <p class="modal-content">
        {{ description }}
      </p>
    </template>
  </ConfirmModal>
</template>

<script setup lang="ts">
const props = defineProps<{
  visible: boolean
  apiStatus?: 'success' | 'fail'
  rewardResultType?: ReferralRewardResult
  onComplete?: () => void
  onGoHome?: () => void
}>()

const emits = defineEmits(['close'])

const REWARD_RESULT_MESSAGES: Record<ReferralRewardResult, { title: string; description: string }> =
  {
    SUCCESS: {
      title: '적립금 받기 완료',
      description: '선물 받은 1,000원 적립금\n 확인하러 가실까요?'
    },
    ALREADY_RECEIVED: {
      title: '이미 초대 적립금을 받으셨어요',
      description: '초대 적립금은 한 번만\n 받을 수 있습니다'
    },
    SAME_PHONE_NUMBER: {
      title: '이미 이전에 가입된 휴대폰 번호예요',
      description: '초대 적립금은 신규 휴대폰 번호에만\n 적용됩니다.'
    },
    NO_REFERRAL_CODE: {
      title: '다른 경로로 가입하셨어요',
      description: '초대 링크로 가입하고 데이터 적립금 받기를\n 눌러야 적립금을 받을 수 있어요.'
    },
    SELF_INVITATION: {
      title: '본인을 초대할 수는 없어요',
      description: '본인이 아닌 친구에게 초대 링크를\n 공유해 보세요.'
    },
    DUPLICATE_INVITATION: {
      title: '이미 초대로 가입된 휴대폰 번호예요',
      description: '해당 번호는 이미 초대 링크로\n 가입된 번호입니다.'
    }
  }

const FALLBACK_TITLE = '다시 시도해 주세요'
const FALLBACK_DESCRIPTION = '일시적인 오류가 발생했습니다.\n잠시 후 다시 시도해 주세요.'

const title = computed(() => {
  if (props.apiStatus === 'fail') return FALLBACK_TITLE
  return REWARD_RESULT_MESSAGES[props.rewardResultType]?.title || FALLBACK_TITLE
})

const description = computed(() => {
  if (props.apiStatus === 'fail') return FALLBACK_DESCRIPTION
  return REWARD_RESULT_MESSAGES[props.rewardResultType]?.description || FALLBACK_DESCRIPTION
})

const isRewardComplete = computed(() => {
  return props.apiStatus === 'success' && props.rewardResultType === 'SUCCESS'
})

const handleConfirm = () => {
  if (isRewardComplete.value) {
    props.onComplete?.()
  } else {
    emits('close')
  }
}

const handleClose = () => {
  if (isRewardComplete.value) {
    props.onGoHome?.()
  } else {
    emits('close')
  }
}
</script>

<style lang="scss" scoped>
.modal-content {
  white-space: pre-line;
}
</style>
